/**
 * 金额格式化:后端一律整数「分」传输,前端统一 `/100` + 千分位 + 2 位小数。
 * 口径同 web-pages 全集(earnings/withdraw-account):`¥X,XXX.XX`。
 * 抽佣 5% / 卖家 95% 的计算真源在后端 `OrderDomainService.computeCommission`(settlement-rules §一);
 * 前端**只格式化、不重算比例**。
 */

/** 分 → 元(数值),四舍五入到分;非法输入回退 0。 */
export function fenToYuan(fen: number | null | undefined): number {
  if (typeof fen !== 'number' || !Number.isFinite(fen)) return 0;
  return Math.round(fen) / 100;
}

/**
 * 分 → 展示串 `¥X,XXX.XX`(千分位 + 固定 2 位小数)。
 * 负数前置负号(退款/扣减场景):`-¥6.00`。
 */
export function formatYuan(fen: number | null | undefined): string {
  const yuan = fenToYuan(fen);
  const sign = yuan < 0 ? '-' : '';
  const abs = Math.abs(yuan);
  const str = abs.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${sign}¥${str}`;
}
